<template>
    <div class="ListingEnquiry">
          <el-alert
                v-if="success === true"
                title="Thanks, your inquiry has been sent successfully."
                type="success"
                show-icon>
            </el-alert>
            <el-alert
                v-if="error === true"
                title="There was an error sending your message, please try again later."
                type="error"
                show-icon>
            </el-alert>
        <div v-if="isLoggedIn">
            <el-form :label-position="labelPosition"  ref="form" :model="form" label-width="120px" :rules="$store.state.general.language === 'english' ? rules : rulesJp" v-show="showForm">
            <b><p>{{'Inquire about this property' | language}}</p></b>
                <el-form-item :label="'Message' | language" prop="message">
                    <el-input :placeholder="'Message' | language" type="textarea" v-model="form.message" rows="4" @keyup.enter.native="onSubmit('form')" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" width="100%" @click="onSubmit('form')" :loading="loading">{{'Submit' | language}}</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div v-else>
             <!-- <el-button @click="login">{{'Login' | language}}</el-button> -->
              <el-form :label-position="labelPosition"  ref="guestForm" :model="guestForm" label-width="120px" :rules="$store.state.general.language === 'english' ? guestRules : guestRulesJp" v-show="showForm">
                {{'Inquire about this property' | language}} ?
                <el-form-item :label="'Email' | language" prop="email">
                    <el-input :placeholder="'Email' | language" v-model="guestForm.email" @keyup.enter.native="guestSubmit('guestForm')"></el-input>
                </el-form-item>
                <el-form-item :label="'Message' | language" prop="message">
                    <el-input :placeholder="'Message' | language" type="textarea" v-model="guestForm.message" rows="4" @keyup.enter.native="guestSubmit('guestForm')"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" width="100%" @click="guestSubmit('guestForm')" :loading="loading">{{'Submit' | language}}</el-button>
                </el-form-item>
                <el-form-item class="guest-form">
                      <el-link type="info"  :underline="false" @click="login">{{'Login' | language}}</el-link>
                      <el-link type="info"  :underline="false" @click="register">{{'Create an Account' | language}}</el-link>
                </el-form-item>
            </el-form>
            
        </div>
    </div>
</template>

<script>
    import LoginModal from '../Pages/Login/Modal'
    import propertyService from '../../services/propertyService'

    export default {
        props:{
            propertyId:Number
        },
        data() {
            return {
                labelPosition: 'top',
                form: {
                    message: '',
                },
                guestForm:{
                    message: '',
                    email:''
                },
                 error: false,
                loading: false,
                success: false,
                rules: {
                    message: [
                        { message: 'Message is required', required: true }
                    ],
                },
                rulesJp: {
                    message: [
                        { message: 'メッセージが必要です', required: true }
                    ],
                },
                guestRules:{
                    message: [
                        { message: 'Message is required', required: true }
                    ],
                    email:[
                        { required: true, message: 'Please input email address'},
                        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] }                    
                    ]
                },
                guestRulesJp:{
                    message: [
                        { message: 'メッセージが必要です', required: true }
                    ],
                    email:[
                        { required: true, message: 'メールアドレスを入力してください'},
                        { type: 'email', message: '正しいメールアドレスを入力してください', trigger: ['blur', 'change'] }                    
                    ]
                },
                showForm:true
            }
        },
        computed:{
            isLoggedIn() {
                return this.$store.getters['user/isLoggedIn']
            }
        },
        methods: {
            onSubmit(formName) {
                 event.preventDefault()
                 this.$refs[formName].validate((valid) => {
                    if (valid) {
                      this.loading = true
                      this.success = false
                      this.error = false
                      propertyService.sendEnquire(this.propertyId,this.form)
                      .then(resp => {
                        this.success = true
                        this.showForm = false
                      })
                      .catch(err=>{
                        this.error = true
                      })
                      .finally(()=>{
                          this.loading = false
                      })
                    } else {
                        return false;
                    }
                });
            },
            guestSubmit(formName){
                event.preventDefault()
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                      this.loading = true
                      this.success = false
                      this.error = false
                      propertyService.sendGuestEnquire(this.propertyId,this.guestForm)
                      .then(resp => {
                        this.success = true
                        this.showForm = false
                      })
                      .catch(err=>{
                        this.error = true
                      })
                      .finally(()=>{
                          this.loading = false
                      })
                    } else {
                        return false;
                    }
                });
            },
            login(){
                this.$modal.show(LoginModal, {
                    }, {
                        name: 'login-modal',
                        width: '100%',
                        maxWidth: 350,
                        height: 'auto',
                        adaptive: true,
                        scrollable: true,
                    })
            },
            register(){
                this.$router.push('/register')
            }
        }
    }
</script>

<style lang="scss">
    .ListingEnquiry {
        padding: 1.5rem;
        margin: 1rem 0 0 0;
        background-color: rgb(248, 248, 248);
        border-radius: $border-radius;
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 1em;

        p {
            margin: 0;
        }

        h5 {
            margin-top: 0;
        }

        .el-form--label-top .el-form-item__label {
            line-height: 1em;
        }

        .el-form-item {
            margin-top: .5em!important;
        }

        .el-button {
            margin-top: 1rem;
            width: 100%;
        }

        .el-form-item__content{
            display:flex;
            justify-content: space-between;
            align-items: center;
        }

    }
</style>



